/**
 * 配置说明
 * title: 跳转页面自动设置头部标题
 */
export default [
  {
    name: 'TaskCenterIndex',
    path: '/task-center',
    component: () =>
      import(
        /* webpackChunkName: "TaskCenterIndex" */ '@/views/task-center/new-task/index.vue'
      ),
    meta: { title: '任务奖励' },
  },
  {
    name: 'TaskCenterDetail',
    path: '/task-center/detail',
    component: () =>
      import(
        /* webpackChunkName: "TaskCenterDetail" */ '@/views/task-center/new-task/components/detail.vue'
      ),
    meta: { title: '任务详情' },
  },
  {
    name: 'TaskCenterRewards',
    path: '/task-center/rewards',
    component: () =>
      import(
        /* webpackChunkName: "TaskCenterRewards" */ '@/views/task-center/rewards'
      ),
    meta: { title: '奖励记录' },
  },
];
